// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/work_item.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AssignWorkItemRequest, BulkDeleteWorkItemsRequest, BulkDeleteWorkItemsResponse, ConfigOption, CreateConfigOptionRequest, CreateStatusTransitionRequest, CreateWorkItemRequest, DeleteConfigOptionRequest, DeleteStatusTransitionRequest, DeleteWorkItemRequest, GetWorkItemRequest, LinkWorkItemConversationRequest, ListConfigOptionsRequest, ListConfigOptionsResponse, ListStatusTransitionsRequest, ListStatusTransitionsResponse, ListWorkItemsRequest, ListWorkItemsResponse, StatusTransition, StreamWorkItemEventsRequest, UnassignWorkItemRequest, UpdateConfigOptionRequest, UpdateWorkItemRequest, WorkItem, WorkItemEvent } from "./work_item_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.WorkItemService
 */
export const WorkItemService = {
  typeName: "omnios.v1.WorkItemService",
  methods: {
    /**
     * @generated from rpc omnios.v1.WorkItemService.CreateWorkItem
     */
    createWorkItem: {
      name: "CreateWorkItem",
      I: CreateWorkItemRequest,
      O: WorkItem,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.WorkItemService.GetWorkItem
     */
    getWorkItem: {
      name: "GetWorkItem",
      I: GetWorkItemRequest,
      O: WorkItem,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.WorkItemService.UpdateWorkItem
     */
    updateWorkItem: {
      name: "UpdateWorkItem",
      I: UpdateWorkItemRequest,
      O: WorkItem,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.WorkItemService.DeleteWorkItem
     */
    deleteWorkItem: {
      name: "DeleteWorkItem",
      I: DeleteWorkItemRequest,
      O: WorkItem,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.WorkItemService.ListWorkItems
     */
    listWorkItems: {
      name: "ListWorkItems",
      I: ListWorkItemsRequest,
      O: ListWorkItemsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.WorkItemService.AssignWorkItem
     */
    assignWorkItem: {
      name: "AssignWorkItem",
      I: AssignWorkItemRequest,
      O: WorkItem,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.WorkItemService.UnassignWorkItem
     */
    unassignWorkItem: {
      name: "UnassignWorkItem",
      I: UnassignWorkItemRequest,
      O: WorkItem,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.WorkItemService.LinkConversation
     */
    linkConversation: {
      name: "LinkConversation",
      I: LinkWorkItemConversationRequest,
      O: WorkItem,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.WorkItemService.StreamEvents
     */
    streamEvents: {
      name: "StreamEvents",
      I: StreamWorkItemEventsRequest,
      O: WorkItemEvent,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * Config option management
     *
     * @generated from rpc omnios.v1.WorkItemService.CreateConfigOption
     */
    createConfigOption: {
      name: "CreateConfigOption",
      I: CreateConfigOptionRequest,
      O: ConfigOption,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.WorkItemService.UpdateConfigOption
     */
    updateConfigOption: {
      name: "UpdateConfigOption",
      I: UpdateConfigOptionRequest,
      O: ConfigOption,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.WorkItemService.DeleteConfigOption
     */
    deleteConfigOption: {
      name: "DeleteConfigOption",
      I: DeleteConfigOptionRequest,
      O: ConfigOption,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.WorkItemService.ListConfigOptions
     */
    listConfigOptions: {
      name: "ListConfigOptions",
      I: ListConfigOptionsRequest,
      O: ListConfigOptionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Status transition management
     *
     * @generated from rpc omnios.v1.WorkItemService.CreateStatusTransition
     */
    createStatusTransition: {
      name: "CreateStatusTransition",
      I: CreateStatusTransitionRequest,
      O: StatusTransition,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.WorkItemService.DeleteStatusTransition
     */
    deleteStatusTransition: {
      name: "DeleteStatusTransition",
      I: DeleteStatusTransitionRequest,
      O: StatusTransition,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.WorkItemService.ListStatusTransitions
     */
    listStatusTransitions: {
      name: "ListStatusTransitions",
      I: ListStatusTransitionsRequest,
      O: ListStatusTransitionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.WorkItemService.BulkDeleteWorkItems
     */
    bulkDeleteWorkItems: {
      name: "BulkDeleteWorkItems",
      I: BulkDeleteWorkItemsRequest,
      O: BulkDeleteWorkItemsResponse,
      kind: MethodKind.Unary,
    },
  }
};

